module.exports = __webpack_public_path__ + "img/logo-cna.0182c3cf.png";